import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  return (
    <nav aria-label="Breadcrumb" className="py-3">
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        <li>
          <Link
            to="/"
            className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            {t('breadcrumbHome')}
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1.5">
            <span className="text-foreground-300">
              <i className="ri-arrow-right-s-line text-xs"></i>
            </span>
            {item.to ? (
              <Link
                to={item.to}
                className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}